import { render, staticRenderFns } from "./AddRecord.vue?vue&type=template&id=20a3a9a0&"
import script from "./AddRecord.vue?vue&type=script&lang=js&"
export * from "./AddRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports